export const UNMAPPED_STAMP_PREFIX = 'stamp-signature-signed';

export const STAMP_T2033 = 'stamp-signature-t2033';

export const STAMPS = [STAMP_T2033];

export const isStampField = (fieldName: string): boolean =>
  [UNMAPPED_STAMP_PREFIX, ...STAMPS].some(prefix => fieldName.startsWith(prefix));
